import { render, staticRenderFns } from "./PropertyAreaList.vue?vue&type=template&id=45b75de2&scoped=true"
import script from "./PropertyAreaList.vue?vue&type=script&lang=js"
export * from "./PropertyAreaList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45b75de2",
  null
  
)

export default component.exports